import * as Sentry from '@sentry/browser';

class WebSocketAccessTokenError extends Error {}

let callbacks = [];
const notifyGlobalError = error => {
  callbacks.forEach(cb => cb(error));
};

const onGlobalError = callback => {
  callbacks.push(callback);
  return () => {
    callbacks = callbacks.filter(cb => cb !== callback);
  };
};

const suppressError = (error, message) => {
  if (!message) {
    return;
  }

  if (error?.message && error?.message.indexOf(message) >= 0) {
    return;
  }

  Sentry.captureException(error);
};

export { notifyGlobalError, onGlobalError, suppressError, WebSocketAccessTokenError };
